import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

// Checkbox servizi: spuntato = visibile. Le esclusioni restano allineate con «Professionisti esclusi» del servizio.
export function VisibleServicesPicker({ hiddenIds, onChange, testIdPrefix }) {
  const [services, setServices] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data || [])).catch(() => setServices([]));
  }, []);
  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? services.filter((x) => (x.name || "").toLowerCase().includes(s)) : services;
  }, [services, q]);
  const hidden = hiddenIds || [];
  const toggle = (id) => onChange(hidden.includes(id) ? hidden.filter((x) => x !== id) : [...hidden, id]);
  return (
    <div className="space-y-2" data-testid={`${testIdPrefix}-visible-services`}>
      <div className="flex items-center justify-between gap-2">
        <h4 className="text-sm font-semibold">Servizi visibili</h4>
        <span className="text-[11px] text-muted-foreground" data-testid={`${testIdPrefix}-visible-services-count`}>
          {services.length - hidden.filter((id) => services.some((s) => s._id === id)).length}/{services.length} visibili
        </span>
      </div>
      <p className="text-xs text-muted-foreground">Togli la spunta ai servizi che questo professionista (e i suoi collaboratori) non deve vedere né acquistare.</p>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca servizio…" data-testid={`${testIdPrefix}-visible-services-search`} />
      <div className="max-h-56 overflow-y-auto rounded-md border divide-y bg-white">
        {shown.length === 0 && <div className="p-3 text-xs text-muted-foreground">Nessun servizio</div>}
        {shown.map((s) => (
          <label key={s._id} className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-slate-50">
            <input
              type="checkbox"
              checked={!hidden.includes(s._id)}
              onChange={() => toggle(s._id)}
              data-testid={`${testIdPrefix}-visible-service-${s._id}`}
            />
            <span className="flex-1 min-w-0 truncate">{s.name}</span>
            <span className="text-[11px] text-muted-foreground whitespace-nowrap">
              {s.category ? `${s.category} · ` : ""}€ {Number(s.base_price || 0).toFixed(2)}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}

export const sameIdSet = (a, b) => {
  const x = new Set(a || []);
  const y = new Set(b || []);
  return x.size === y.size && [...x].every((i) => y.has(i));
};
